import axios from 'axios'
import store from '@/store/'
const { VUE_APP_API, VUE_APP_API_VERSIONING } = process.env

axios.defaults.baseURL = VUE_APP_API

// Request interceptor
axios.interceptors.request.use(request => {
	const token = store.getters.apiToken

	if (token) {
		axios.defaults.baseURL = VUE_APP_API_VERSIONING
		request.headers.common.Authorization = `Bearer ${token}`
	}

	return request
})

axios.interceptors.response.use(response => response, error => {
	const { status } = error.response

	if (status >= 500) {

	}

	if (status === 401 && store.getters.getLoggedInState) {

	}

	return Promise.reject(error)
})
